import { render, staticRenderFns } from "./BarcodeReader.vue?vue&type=template&id=0e8d1507&scoped=true&"
import script from "./BarcodeReader.vue?vue&type=script&lang=js&"
export * from "./BarcodeReader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8d1507",
  null
  
)

export default component.exports